import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const RunxSvg: React.FC<SvgProps> = ({
  width = "47",
  height = "13",
  viewBox = "0 0 47 13",
  color = "#FFFBF0",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.74119 0.501479H0V12.3639H2.53931V6.78839L4.52107 7.1108C6.94281 7.50049 7.33251 8.44922 7.33251 9.9067V12.3639H9.88957V9.63532C9.88957 8.12682 9.19596 7.2964 7.92556 6.9067C8.94232 6.60131 10.1617 5.97498 10.1617 3.99174C10.1617 1.83991 8.45132 0.501479 5.74119 0.501479ZM7.69041 4.50123C7.69041 5.77163 6.84299 6.53401 5.64062 6.53401H2.54079V2.62004H5.64062C6.84299 2.62004 7.69041 3.40017 7.69041 4.50123ZM20.5622 8.3982V12.4985C21.9517 12.4985 23.103 11.532 23.103 9.97325V5.66958L20.5622 8.05953C18.6315 9.87269 17.1585 10.3814 15.9214 10.3814C14.8713 10.3814 14.194 9.60278 14.194 8.41595V0.501479H11.6532V8.6511C11.6532 10.8724 13.0937 12.4985 15.1597 12.4985C17.2258 12.4985 18.5805 11.3634 20.5622 8.3982ZM23.103 0.5C21.7136 0.5 20.5622 1.46648 20.5622 3.02526V3.02674H20.5608V7.33189L23.1015 4.94195C25.0323 3.12879 26.506 2.62004 27.7927 2.62004C28.825 2.62004 29.4691 3.34915 29.4691 4.50123V12.5H32.0099V4.26313C32.0099 1.72159 30.5198 0.501479 28.7244 0.501479C26.4898 0.501479 25.084 1.63655 23.103 4.6018V0.5ZM46.7843 0.5H45.0939L40.8531 5.50247L40.0072 6.5L34.9204 12.4993H36.6116L40.2911 8.16009C40.5854 7.81255 41.1208 7.81255 41.4158 8.16009L45.0954 12.4993H46.7858L42.1139 6.98952C41.8743 6.70705 41.8743 6.29295 42.1139 6.01122L46.7843 0.5ZM39.7987 4.17661L36.6811 0.5H34.9907L39.7987 6.17094C40.2868 5.59564 40.2868 4.75191 39.7987 4.17587V4.17661Z"
        fill={color}
      />
    </svg>
  );
};

export { RunxSvg };
